import { createRouter, createWebHistory } from 'vue-router'
import { useAuthStore } from '@/stores/auth'
import { usePersonalizationStore } from '@/stores/personalization'

const routes = [
  {
    path: '/',
    redirect: '/dashboard'
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/auth/LoginView.vue'),
    meta: { requiresGuest: true }
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import('@/views/auth/RegisterView.vue'),
    meta: { requiresGuest: true }
  },
  {
    path: '/personalisasi',
    name: 'Personalization',
    component: () => import('@/views/personalization/PersonalizationForm.vue'),
    meta: { requiresAuth: true, skipPersonalizationCheck: true, roles: ['mahasiswa'] }
  },
  {
    path: '/pilih-konselor',
    name: 'CounselorSelection',
    component: () => import('@/views/personalization/CounselorSelectionView.vue'),
    meta: { requiresAuth: true, skipPersonalizationCheck: true, roles: ['mahasiswa'] }
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: () => import('@/views/dashboard/DashboardLayout.vue'),
    meta: { requiresAuth: true },
    children: [
      {
        path: '',
        name: 'DashboardHome',
        component: () => import('@/views/dashboard/HomeView.vue')
      },
      // Admin Routes
      // Form Builder - REMOVED for simplification (testing phase)
      // {
      //   path: 'forms',
      //   name: 'FormManagement',
      //   component: () => import('@/views/forms/FormListView.vue'),
      //   meta: { roles: ['admin', 'konselor'] }
      // },
      // {
      //   path: 'forms/create',
      //   name: 'CreateForm',
      //   component: () => import('@/views/forms/FormCreateView.vue'),
      //   meta: { roles: ['admin', 'konselor'] }
      // },
      // {
      //   path: 'forms/:id',
      //   name: 'ViewForm',
      //   component: () => import('@/views/forms/FormCreateView.vue'),
      //   meta: { roles: ['admin', 'konselor'] }
      // },
      // {
      //   path: 'forms/:id/edit',
      //   name: 'EditForm',
      //   component: () => import('@/views/forms/FormCreateView.vue'),
      //   meta: { roles: ['admin', 'konselor'] }
      // },
      // {
      //   path: 'forms/:id/responses',
      //   name: 'FormResponses',
      //   component: () => import('@/views/forms/FormListView.vue'),
      //   meta: { roles: ['admin', 'konselor'] }
      // },
      {
        path: 'users',
        name: 'UserManagement',
        component: () => import('@/views/users/UserListView.vue'),
        meta: { roles: ['admin'] }
      },
      {
        path: 'users/create',
        name: 'CreateUser',
        component: () => import('@/views/users/UserCreateView.vue'),
        meta: { roles: ['admin'] }
      },
      {
        path: 'users/:id/edit',
        name: 'EditUser',
        component: () => import('@/views/users/UserEditView.vue'),
        meta: { roles: ['admin'] }
      },
      {
        path: 'content',
        name: 'ContentManagement',
        component: () => import('@/views/content/ContentListView.vue'),
        meta: { roles: ['admin'] }
      },
      {
        path: 'content/create',
        name: 'CreateContent',
        component: () => import('@/views/content/ContentListView.vue'),
        meta: { roles: ['admin'] }
      },
      {
        path: 'content/:id',
        name: 'ViewContent',
        component: () => import('@/views/content/ContentListView.vue'),
        meta: { roles: ['admin'] }
      },
      {
        path: 'content/:id/edit',
        name: 'EditContent',
        component: () => import('@/views/content/ContentListView.vue'),
        meta: { roles: ['admin'] }
      },

      // Master Data Management (Admin only)
      {
        path: 'fakultas',
        name: 'FakultasManagement',
        component: () => import('@/views/admin/FakultasListView.vue'),
        meta: { roles: ['admin'] }
      },
      {
        path: 'program-studi',
        name: 'ProgramStudiManagement',
        component: () => import('@/views/admin/ProgramStudiListView.vue'),
        meta: { roles: ['admin'] }
      },
      {
        path: 'jenjang',
        name: 'JenjangManagement',
        component: () => import('@/views/admin/JenjangListView.vue'),
        meta: { roles: ['admin'] }
      },
      {
        path: 'categories',
        name: 'CategoriesManagement',
        component: () => import('@/views/admin/CategoriesListView.vue'),
        meta: { roles: ['admin'] }
      },
      // Admin Schedule Routes
      {
        path: 'admin/schedules',
        name: 'AdminScheduleDashboard',
        component: () => import('@/views/admin/ScheduleDashboardView.vue'),
        meta: { roles: ['admin'] }
      },
      {
        path: 'admin/schedules/list',
        name: 'AdminScheduleList',
        component: () => import('@/views/admin/ScheduleListView.vue'),
        meta: { roles: ['admin'] }
      },
      {
        path: 'admin/counseling/requests',
        name: 'AdminCounselingRequests',
        component: () => import('@/views/admin/CounselingRequestsView.vue'),
        meta: { roles: ['admin'] }
      },
      {
        path: 'admin/sessions',
        name: 'AdminSessions',
        component: () => import('@/views/admin/AdminSessionsView.vue'),
        meta: { roles: ['admin'] }
      },
      {
        path: 'admin/feedback',
        name: 'AdminFeedbackDashboard',
        component: () => import('@/views/admin/AdminFeedbackDashboard.vue'),
        meta: { roles: ['admin'] }
      },
      {
        path: 'admin/feedback/list',
        name: 'AdminFeedbackList',
        component: () => import('@/views/admin/FeedbackListView.vue'),
        meta: { roles: ['admin'] }
      },
      {
        path: 'admin/feedback/:id',
        name: 'AdminFeedbackDetail',
        component: () => import('@/views/admin/FeedbackDetailView.vue'),
        meta: { roles: ['admin'] }
      },
      {
        path: 'admin/content-analytics',
        name: 'AdminContentAnalytics',
        component: () => import('@/views/admin/ContentAnalyticsView.vue'),
        meta: { roles: ['admin'] }
      },
      {
        path: 'admin/ml-retrain',
        name: 'AdminMLRetrain',
        component: () => import('@/views/admin/MLRetrainView.vue'),
        meta: { roles: ['admin'] }
      },
      // Mahasiswa Schedule Routes
      {
        path: 'schedules',
        name: 'MahasiswaSchedules',
        component: () => import('@/views/student/MahasiswaScheduleListView.vue'),
        meta: { roles: ['mahasiswa'] }
      },
      // Konselor Schedule Routes
      {
        path: 'konselor/schedules',
        name: 'KonselorSchedules',
        component: () => import('@/views/counselor/KonselorScheduleListView.vue'),
        meta: { roles: ['konselor'] }
      },
      {
        path: 'konselor/sessions',
        name: 'KonselorSessions',
        component: () => import('@/views/counselor/KonselorSessionsView.vue'),
        meta: { roles: ['konselor'] }
      },
      // KonselorAvailability merged into KonselorSessions as a tab
      // Konselor Feedback Routes
      {
        path: 'konselor/feedback',
        name: 'KonselorFeedback',
        component: () => import('@/views/konselor/KonselorFeedbackView.vue'),
        meta: { roles: ['konselor'] }
      },
      {
        path: 'feedback',
        name: 'FeedbackManagement',
        component: () => import('@/views/feedback/FeedbackView.vue'),
        meta: { roles: ['admin', 'konselor', 'mahasiswa'] }
      },
      {
        path: 'history',
        name: 'HistoryManagement',
        component: () => import('@/views/history/HistoryView.vue'),
        meta: { roles: ['admin', 'konselor', 'mahasiswa'] }
      },
      {
        path: 'activity-history',
        name: 'ActivityHistory',
        component: () => import('@/views/student/ActivityHistoryView.vue'),
        meta: { roles: ['mahasiswa'] }
      },
      // Student Routes

      {
        path: 'content-library',
        name: 'ContentLibrary',
        component: () => import('@/views/student/ContentLibraryView.vue'),
        meta: { roles: ['mahasiswa'] }
      },
      {
        path: 'content-library/:id',
        name: 'ViewContentDetail',
        component: () => import('@/views/student/ContentDetailView.vue'),
        meta: { roles: ['mahasiswa'] }
      },
      {
        path: 'recommendations',
        name: 'StudentRecommendations',
        component: () => import('@/views/student/RecommendationsView.vue'),
        meta: { roles: ['mahasiswa'] }
      },
      {
        path: 'old-recommendations',
        name: 'Recommendations',
        component: () => import('@/views/student/RecommendationsView.vue'),
        meta: { roles: ['mahasiswa'] }
      },
      {
        path: 'my-sessions',
        name: 'MySessions',
        component: () => import('@/views/student/SessionsView.vue'),
        meta: { roles: ['mahasiswa'] }
      },
      // Counseling Request Routes (NEW)
      {
        path: 'counseling/request',
        name: 'CounselingRequest',
        component: () => import('@/views/student/CounselingRequestView.vue'),
        meta: { roles: ['mahasiswa'] }
      },
      {
        path: 'counseling/my-requests',
        name: 'MyCounselingRequests',
        component: () => import('@/views/student/MyCounselingRequestsView.vue'),
        meta: { roles: ['mahasiswa'] }
      },
      // Feedback Routes (Mahasiswa)
      {
        path: 'mahasiswa/feedback',
        name: 'MyFeedback',
        component: () => import('@/views/mahasiswa/MyFeedbackView.vue'),
        meta: { roles: ['mahasiswa'] }
      },
      // Notifications
      {
        path: 'notifications',
        name: 'Notifications',
        component: () => import('@/views/notifications/NotificationsView.vue'),
        meta: { roles: ['admin', 'konselor', 'mahasiswa'] }
      },
      // Shared Routes
      {
        path: 'profile',
        name: 'Profile',
        component: () => import('@/views/profile/ProfileView.vue')
      }
    ]
  },
  {
    path: '/form/:slug',
    name: 'PublicForm',
    component: () => import('@/views/forms/PublicFormView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/tailwind-test',
    name: 'TailwindTest',
    component: () => import('@/components/TailwindTest.vue')
  },
  {
    path: '/unauthorized',
    name: 'Unauthorized',
    component: () => import('@/views/errors/UnauthorizedView.vue')
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: () => import('@/views/errors/NotFoundView.vue')
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { top: 0 }
    }
  }
})

router.beforeEach(async (to, from, next) => {
  const authStore = useAuthStore()
  const personalizationStore = usePersonalizationStore()

  // Wait for auth initialization if not yet initialized
  if (!authStore.initialized && authStore.token) {
    await authStore.checkAuth()
  }

  const isAuthenticated = authStore.isAuthenticated
  const userRole = authStore.user?.role

  // Check if route requires authentication
  if (to.meta.requiresAuth && !isAuthenticated) {
    next('/login')
    return
  }

  // Check if route requires guest (not authenticated)
  if (to.meta.requiresGuest && isAuthenticated) {
    next('/dashboard')
    return
  }

  // Check role-based access
  if (to.meta.roles && !to.meta.roles.includes(userRole)) {
    next('/unauthorized') // Redirect to unauthorized page if user doesn't have required role
    return
  }

  // Check personalization completion for mahasiswa
  if (isAuthenticated && userRole === 'mahasiswa' && !to.meta.skipPersonalizationCheck) {
    // Non-blocking check - fetch status in background without blocking navigation
    if (personalizationStore.status.completed === false &&
        personalizationStore.status.required === false) {
      // Fetch status in background, don't block navigation
      personalizationStore.checkStatus().catch(err => {
        console.error('Failed to check personalization status:', err)
      })
    }

    // Step 1: Check if personalization form is completed
    // Counselor selection is now part of scheduling, not onboarding
    if (personalizationStore.isRequired && !personalizationStore.status.personalization_form_completed) {
      if (to.name !== 'Personalization') {
        next('/personalisasi')
        return
      }
    }

    // If personalization completed and trying to access personalization page, redirect to dashboard
    if (personalizationStore.status.personalization_form_completed && to.name === 'Personalization') {
      next('/dashboard')
      return
    }
  }

  next()
})

export default router